import { GestureTapButtonIcon } from './GestureTapButtonIcon';

/**
 * author: Michael Irigoyen
 * id 51E5488F-71C4-4E08-950D-EAAAB7B22D53
 * name gesture-tap-button
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gesture-tap-button.svg
 * tags
 * - Form 
 */
export const GestureTouchButtonIcon = GestureTapButtonIcon;
export default GestureTouchButtonIcon